import { TabList, Tab, makeStyles, tokens, type SelectTabData } from '@fluentui/react-components';

export interface SubTabDef {
  value: string;
  label: string;
}

const useStyles = makeStyles({
  // Con muchas pestañas no deben recortarse: scroll horizontal delgado y sin wrap.
  list: {
    flexWrap: 'nowrap',
    overflowX: 'auto',
    paddingBottom: '4px',
    scrollbarWidth: 'thin',
    '& > *': { flexShrink: 0 },
    '&::-webkit-scrollbar': { height: '6px' },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: tokens.colorNeutralStroke1,
      borderRadius: tokens.borderRadiusCircular,
    },
  },
});

interface Props {
  tabs: SubTabDef[];
  ariaLabel?: string;
  selected: string;
  onSelect: (value: string) => void;
}

/** Pestañas secundarias compactas para alternar entre 2 vistas relacionadas
 * dentro de una misma página (ej. Resumen/Progreso, Resumen/Análisis) sin
 * duplicar entradas de Sidebar — envuelve `TabList` de FluentUI, que ya es el
 * patrón usado en el resto del dashboard (FinancePage, CropPage, MapPage). */
export function SubTabs({ tabs, selected, onSelect, ariaLabel }: Props) {
  const s = useStyles();
  return (
    <TabList
      size="small"
      className={s.list}
      aria-label={ariaLabel}
      selectedValue={selected}
      onTabSelect={(_, d: SelectTabData) => onSelect(d.value as string)}
    >
      {tabs.map(t => <Tab key={t.value} value={t.value}>{t.label}</Tab>)}
    </TabList>
  );
}
